import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../components/Navbar";
import {
    useEditVideoMutation,
    useGetVideoQuery,
} from "../../../features/videos/videoApi";

const EditQuiz = () => {
  const { id } = useParams();
  const { data: video } = useGetVideoQuery(id);

  const navigate = useNavigate();
  const [editVideo, { data, isLoading, error }] = useEditVideoMutation();
  const [state, setState] = React.useState({
    title: "",
    description: "",
    url: "",
    views: "",
    duration: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      ...state,
      id,
      createdAt: new Date().toISOString(),
    };
    editVideo(data);
    navigate("/admin/videos");
  };
  useEffect(() => {
    if (video) {
      setState({
        title: video.title,
        description: video.description,
        url: video.url,
        views: video.views,
        duration: video.duration,
      });
    }
  }, [video]);
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="px-3 lg:px-0 py-20 bg-opacity-10">
            <div className="w-full flex items-center">
              <h1 className="text-2xl font-bold">Add Video</h1>
              <Link to="/admin/videos" className="btn ml-auto">
                All Videos
              </Link>
            </div>
            <div className="overflow-x-auto mt-4">
              <form onSubmit={handleSubmit}>
                <div className="flex flex-row gap-4 mb-8">
                  <div className="flex flex-col input-group">
                    <label htmlFor="title">Title</label>
                    <input
                      type="text"
                      name="title"
                      id="title"
                      placeholder="Debounce Function in JavaScript..."
                      value={state.title}
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="flex flex-col input-group">
                    <label htmlFor="description">Description</label>
                    <textarea
                      type="text"
                      name="description"
                      id="description"
                      placeholder="I have explained about the debounce function..."
                      value={state.description}
                      required
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="flex flex-row gap-4 mb-8">
                  <div className="flex flex-col input-group">
                    <label htmlFor="url">Url</label>
                    <input
                      type="text"
                      name="url"
                      id="url"
                      placeholder="https://www.youtube.com/watch?v=KcQdJ..."
                      value={state.url}
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="flex flex-col input-group">
                    <label htmlFor="views">Views</label>
                    <input
                      type="text"
                      name="views"
                      id="views"
                      placeholder="51.2K"
                      value={state.views}
                      required
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="flex flex-row gap-4 mb-8">
                  <div className="flex flex-col input-group">
                    <label htmlFor="duration">Duration</label>
                    <input
                      type="text"
                      name="duration"
                      id="duration"
                      placeholder="5:30"
                      required
                      value={state.duration}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <button className="group relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500 mx-auto">
                  Save Video
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EditQuiz;
